import React, { Component } from 'react'
import { Collapse } from "react-bootstrap";

class JSONDebugger extends Component {
    state = {}
    render() {
        return (
            <div style={{ marginTop: 10 }}>
                <div style={{ cursor: 'pointer', color: '#ccc' }} onClick={() => this.setState({ openDebug: !this.state.openDebug })} >show/hide debug</div>
                <Collapse in={this.state.openDebug}>
                    <div>
                        <pre className="debugger">
                            <h4>{this.props.title || 'Debugger'}</h4>
                            {JSON.stringify(this.props.json, null, 2)}
                        </pre>
                    </div>
                </Collapse>
            </div>

        )
    }
}

export default JSONDebugger

